module.exports = __webpack_public_path__ + "img/ic_burger_home.34ae7250.svg";